// Expresión JS para los <Script> inline del layout de [locale] (pixel de Meta y tag de
// Google Ads): da true si la página es el 404 de [locale], el de un notFound() de una
// página, como un libro o un video que no existe.
//
// Ahí no va el PageView: es alguien que cayó en un link roto, no una visita al sitio, y
// entraba igual a los públicos de remarketing (lo midió la revisión del 23-sep-2026). La
// carga y el `init` siguen, así los eventos de después (si sigue navegando) andan.
//
// Dos señales, porque ninguna alcanza sola:
// - El status HTTP del documento (responseStatus): lo más directo, pero Safari no lo da.
// - La marca data-bcm-404 de NotFoundContent. En un render dinámico el 404 llega vacío
//   del server y se dibuja en el cliente, pero en el mismo commit que el layout y antes
//   de los efectos, que es donde next/script corre los inline afterInteractive.
export const ES_404_JS =
  "(function(){try{var n=performance.getEntriesByType('navigation')[0];" +
  "if(n&&n.responseStatus===404)return true}catch(e){}" +
  "return !!document.querySelector('[data-bcm-404]')})()";
